import '../App.css';

export default function SignUp() {
  return (
    <h1 className="sign-up" style={{ color: 'black' }}>
      Comming Soon....
    </h1>
  );
}
